import * as React from 'react';

export interface TemperatureChartContextValues {
    barBottom?: number;
    nameY?: number;
    svgWidth?: number;
}

export const TemperatureChartContext = React.createContext<TemperatureChartContextValues>({});
